import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Group 1538231572" }, [
      _createElementVNode("line", {
        id: "Line 24",
        x1: "1.24168",
        y1: "1",
        x2: "18.89",
        y2: "18.6483",
        stroke: "black",
        "stroke-width": "1.756",
        "stroke-linecap": "round"
      }),
      _createElementVNode("line", {
        id: "Line 27",
        x1: "0.877998",
        y1: "-0.877998",
        x2: "25.8365",
        y2: "-0.877998",
        transform: "matrix(-0.707107 0.707107 0.707107 0.707107 20 1)",
        stroke: "black",
        "stroke-width": "1.756",
        "stroke-linecap": "round"
      })
    ], -1)
  ])))
}
export default { render: render }